export interface AuthConfig {
  authProvider: AuthProvider;
  companyName: string;
  enableResetPassword: boolean;
  loginContactEmail: string;
  loginContactName: string;
  loginContactPhone: string;
  loginCustomHtml: string;
  loginHeaderName: string;
  loginShowContactInfo: boolean;
  loginShowStaffLink: boolean;
  loginSubHeader: string;
  selfSignup: {
    additionalText: string;
    enableSelfSignup: boolean;
    restrictedDomains: string[];
  };
  sso: {
    ssoEnabled: boolean;
  };
  websiteId: number;
}

export enum AuthProvider {
  Cognito = 'cognito',
  Legacy = 'legacy',
}
